export default function stripLabel(label: string) {
  return label
    .replace(/\s/g, ' ')
    .replace(/\.[^/.]+$/, '')
    .replace(/[^ -~]+/g, '')
    .trim();
}
